"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const CelebrationPanel = styled_1.default.div `
box-sizing: border-box;
	width: 100%;
	padding: ${merlin_theme_1.default.layout.spacing.small} ${merlin_theme_1.default.layout.spacing.standard};
	background: radial-gradient(100% 100% at 30% 25%, ${merlin_theme_1.default.paletteV5.purple.primary} 50%, ${merlin_theme_1.default.paletteV5.pink.primary} 100%);
	color: ${merlin_theme_1.default.colours.neutral.white};
	border-radius: ${merlin_theme_1.default.layout.radius.default};

	@media only screen and (min-width: 468px) {
		width: 335px;
	}
`;
exports.default = CelebrationPanel;
//# sourceMappingURL=Celebration.js.map